{
    "Profile_CommonComponents_Signature.signDocs": "Sign docs",
    "Profile_CommonComponents_Signature.instructions": "Sign in the box below with a cursor or finger.",
    "Profile_CommonComponents_Signature.errorMessage": "Please Sign in the box before clicking save.",
    "Profile_CommonComponents_Signature.save": "Save",
    "Profile_CommonComponents_Signature.clear": "Clear",
    "Profile_CommonComponents_Signature.cancel": "Cancel"
}
